import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Amplify, Auth, Hub } from 'aws-amplify';
import { from, of } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { map, catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class AmplifyService {
    constructor() {
        this.configureDefault();
    }

    private configureDefault(): void {
        Amplify.configure({
            Auth: {
                region: environment.cognito.region,
                userPoolId: environment.cognito.UserPoolId,
                userPoolWebClientId: environment.cognito.ClientId
                // storage
            }
        });
    }

    login(username: string, password?: string): Promise<any> {
        return Auth.signIn(username, password);
    }


    isAuthenticated(): Observable<boolean> {
        return from(Auth.currentAuthenticatedUser()).pipe(
            map(user => !!user),
            catchError(err => of(false))
        );
    }

    logout(): Observable<void> {
        return from(Auth.signOut().then(r => {
            this.configureDefault();
            return r;
        }));
    }

    getJwt(): Observable<string | null> {
        return from(Auth.currentSession()).pipe(
            map(response => {
                if (response.isValid()) {
                    return response.getAccessToken().getJwtToken();
                }
                return null;
            })
        );
    }

    configureFederatedLogin(appClientId: string, domain: string): void {
        Amplify.configure({
            Auth: {
                region: environment.cognito.region,
                userPoolId: environment.cognito.UserPoolId,
                userPoolWebClientId: appClientId,
                oauth: {
                    domain: domain.replace('https://', ''),
                    scope: ['email', 'openid'],
                    redirectSignIn: `https://${window.location.hostname}/login-ad-auth`,
                    redirectSignOut: `https://${window.location.hostname}/logout`,
                    responseType: 'code'
                },
            }
        });

        localStorage.setItem("federatedAppClientId", appClientId);
    }

    loginFederated(appClientId: string, domain: string, identityProvider: string): void {
        this.configureFederatedLogin(appClientId, domain);

        Auth.federatedSignIn({ customProvider: identityProvider });
    }

}
